import type {ChangeGroupGenerationUnavailableReasons} from '../types/group-types'

export function getChangeGroupGenerationUnavailableMessage(
  reason: ChangeGroupGenerationUnavailableReasons | undefined,
) {
  switch (reason) {
    case 'DIFF_TOO_LARGE':
      return 'Grouping was skipped because this pull request is too large.'
    case 'DIFF_TOO_SMALL':
    case 'TOO_FEW_GROUPS':
      return 'Grouping was skipped because all changes are closely related.'
    case 'TOO_MANY_GROUPS':
      return 'Grouping was skipped because this pull request generates too many groups.'
    case 'UNABLE_TO_GENERATE':
    default:
      return 'Copilot was unable to generate groups for this pull request.'
  }
}
